import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, overline, title, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-baseline gap-4">
      <span className="font-sans text-xs tracking-[0.3em] text-marigold">{index}</span>
      <p className="text-xs uppercase tracking-[0.3em] text-sage">{overline}</p>
    </div>
    <h2 className="mt-5 max-w-2xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-cream sm:text-5xl">
      {title}
    </h2>
  </Reveal>
);

export { EASE };
